import apiClient from "./apiClient";

export const downloadProjectInputFile = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}/api/download-project-input-file/${id}`;

    const response = await apiClient(url, {
        method: 'GET',
    })

    return response;

}

export const handleDownloadProjectInputFile = async (id, t, navigate) => {
    try {
        const response = await downloadProjectInputFile(id)
        if (response.ok) {
            const data = await response.json()
            const link = document.createElement('a');
            link.href = data.url;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        else {
            var props = {
                error_code: "GO9568",
                detail: `${t("Proje dosyası indirilemedi")}: ${response.statusText} (${response.status})`,
            }
            navigate(`/error`, { state: { props: props } })
        }
    }
    catch {
        var props = {
            error_code: "4KDVI0",
            detail: t("Sistem Hatası. Sistem yöneticisi ile irtibata geçin."),
        }

        navigate(`/error`, { state: { props: props } })
    }
}